export function plainCardText(content) {
  const element = document.createElement('div');
  element.innerHTML = String(content || '').replace(/<(?:\/(?:p|div|h[1-6]|li|tr)|br)\b[^>]*>/gi, ' $&');
  return (element.textContent || '').replace(/\s+/g, ' ').trim();
}

export function buildSearchIndex(boxes, planTitle) {
  const byId = new Map(boxes.map(box => [box.id, box]));
  return boxes.map(box => {
    const ancestors = [];
    const visited = new Set([box.id]);
    let parent = byId.get(box.parent_id);
    while (parent && !visited.has(parent.id)) {
      ancestors.unshift(parent.title || 'Untitled card');
      visited.add(parent.id);
      parent = byId.get(parent.parent_id);
    }
    return {
      box,
      title: box.title || 'Untitled card',
      body: box.content_type === 'image' ? '' : plainCardText(box.content),
      path: [planTitle, ...ancestors].join(' › '),
    };
  });
}

export function searchCards(index, query) {
  const term = query.trim().replace(/\s+/g, ' ').toLocaleLowerCase();
  if (!term) return [];
  return index.map(item => {
    const titleMatch = item.title.toLocaleLowerCase().indexOf(term);
    const bodyMatch = item.body.toLocaleLowerCase().indexOf(term);
    if (titleMatch < 0 && bodyMatch < 0) return null;
    const rank = titleMatch === 0 ? 0 : titleMatch > 0 ? 1 : 2;
    const start = Math.max(0, bodyMatch - 55);
    const end = Math.min(item.body.length, (bodyMatch < 0 ? 0 : bodyMatch) + term.length + 85);
    const snippet = item.body && (bodyMatch >= 0 || titleMatch >= 0)
      ? `${start ? '…' : ''}${item.body.slice(start, end)}${end < item.body.length ? '…' : ''}`
      : '';
    return { ...item, rank, snippet };
  }).filter(Boolean).sort((first, second) =>
    first.rank - second.rank || Number(second.box.updated_at) - Number(first.box.updated_at)
  ).slice(0, 50);
}
